export class BusinessFilter  {
    readonly BUSINESS_ACCOMMODATION: string = "72";
    readonly BUSINESS_ADMIN: string = "56";
    readonly BUSINESS_AGRICULTURE: string = "11";
    readonly BUSINESS_ARTS: string = "71";
    readonly BUSINESS_CONSTRUCTION: string = "23";
    readonly BUSINESS_EDUCATION: string = "61";
    readonly BUSINESS_FINANCE: string = "52";
    readonly BUSINESS_HEALTH: string = "62";
    readonly BUSINESS_MANAGEMENT: string = "55";
    readonly BUSINESS_INFO: string = "51";
    readonly BUSINESS_MANUFACTURE: string = "31";
    readonly BUSINESS_MINING: string = "21";
    readonly BUSINESS_OTHER: string = "81";
    readonly BUSINESS_PROFESSIONAL: string = "54";
    readonly BUSINESS_PUBLIC: string = "92";
    readonly BUSINESS_REAL_ESTATE: string = "53";
    readonly BUSINESS_RETAIL: string = "44";
    readonly BUSINESS_TRANSPORTATION: string = "49";
    readonly BUSINESS_UTILITIES: string = "22";
    readonly BUSINESS_WHOLESALE: string = "42";
}